module.exports = __webpack_public_path__ + "img/num2.87cba91b.svg";